/**
 * Decide se a UI pode roubar o foco de um campo de texto sem o usuário ter
 * tocado nele.
 *
 * Em aparelho de toque, focar um `<input>`/`contenteditable` **abre o teclado
 * virtual**, que come metade da tela. O que no desktop é conveniência (o caret
 * já está no lugar) no celular é a tela mudando de tamanho sozinha, antes de a
 * pessoa ter lido qualquer coisa.
 *
 * O sinal é `pointer: coarse` e não largura de viewport, de propósito:
 * - celular deitado é LARGO e continua sendo dedo;
 * - janela de desktop estreita continua sendo mouse, e ali o auto-foco ajuda.
 *
 * `pointer` (e não `any-pointer`) porque descreve o dispositivo de apontamento
 * PRIMÁRIO: notebook com tela sensível ao toque reporta `fine` e mantém o
 * comportamento de desktop, que é o certo — ali existe teclado físico.
 */

const CONSULTA_PONTEIRO_GROSSO = '(pointer: coarse)'

/** `true` quando o apontador primário é o dedo. */
export function isTouchPrimary(): boolean {
  // SSR e jsdom cru não têm matchMedia. Falhar pro lado de "não é touch"
  // preserva exatamente o comportamento que existia antes desta guarda.
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(CONSULTA_PONTEIRO_GROSSO).matches
}

/**
 * `true` quando é aceitável focar um campo sem gesto do usuário.
 *
 * Medido a cada chamada, nunca cacheado no módulo: teclado externo acoplado,
 * tablet em modo desktop e o device mode do DevTools mudam a resposta em tempo
 * de execução. `matchMedia` não força layout, então consultar é barato.
 */
export function shouldAutoFocus(): boolean {
  return !isTouchPrimary()
}
